import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { IndexedDbService } from './indexedDb.service';
import { Observable } from 'rxjs';
import { map, flatMap } from 'rxjs/operators';
import { AppConstants } from '../../utils/appConstants.class';
import { BaseService } from './baseService';

@Injectable({
  providedIn: 'root'
})
export class SynchronizeService extends BaseService {
  public isLoaded = false;

    // list of tables that should be replaced instead of just adding data
    // I think all tables should be replaced when updating, but tests and analyse are needed to see potential problems when
    // an entry is not found in local table
    private tablesToReplace = [
      // permissions,
      // languages,
      // pluginModels,
      // applicationTypes,
      // currencies,
      // localEntities,
      // countries,
      'models'
      // productLines,
      // categories
  ];

  constructor(private api: ApiService, private indexedDb: IndexedDbService) {
    super();
  }

  public synchronizeAppReferentials(): Observable<any> {
    const url = '/synchronization/applicationreferentials/changes';
    const dateKey = `${AppConstants.APP_REF_LAST_SYNC_DATE}_${this.applicationType}_${this.currentUserId}`;
    return this.indexedDb.openDatabase(this.applicationType, this.currentUserId).pipe(
      flatMap((res) => {
        return this.api.post(url, localStorage.getItem(dateKey)).pipe(
          map((data) => {
            Object.keys(data.Items).forEach((key) => {
              this.saveToIndexedDb(data.Items[key], key);
            });
            localStorage.setItem(dateKey, data.AppRefLastSyncDate.toString());
            this.isLoaded = true;
            return data;
          })
        );
      })
    );
  }

  private saveToIndexedDb(data: any[], table: string) {
    if (data && data.length > 0) {
      if (this.tablesToReplace.indexOf(table) >= 0) {
        this.indexedDb.clearTable(table).subscribe(() => {
            data.forEach(d => this.indexedDb.put(table, d));
        });
      } else {
        data.forEach((d) => this.indexedDb.put(table, d));
      }
    }
  }
}
